import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import starIcon from '../../assets/images/star-icon.png'

const OurFeatures = () => {
  const { featureSection, features } = useStaticQuery(
    graphql`
      query {
        featureSection: allContentfulHomeItServices {
          edges {
            node {
              featureSub
              featureTitle
              featureContent
            }
          }
        }
        features: allContentfulFeatures(
          sort: { fields: createdAt, order: DESC }
        ) {
          edges {
            node {
              title
              content
              image {
                fluid(maxWidth: 78) {
                  ...GatsbyContentfulFluid_withWebp_noBase64
                }
              }
            }
          }
        }
      }
    `
  )

  const {
    featureSub,
    featureTitle,
    featureContent,
  } = featureSection.edges[0].node

  return (
    <section className="services-area pt-100 pb-70 bg-f1f8fb">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="feature" />
            {featureSub}
          </span>

          <h2>{featureTitle}</h2>
          <p>{featureContent}</p>
        </div>

        {features ? (
          <div className="row">
            {features.edges.map((feature, index) => {
              return (
                <div key={index} className="col-lg-4 col-sm-6">
                  <div className="single-services-item-box">
                    <div className="icon">
                      <Img
                        loading="eager"
                        fadeIn={false}
                        fluid={feature.node.image.fluid}
                        style={{
                          maxWidth: '78px',
                          height: 'auto',
                          margin: '0 auto',
                        }}
                      />
                    </div>
                    <h3>{feature.node.title}</h3>
                    <p>{feature.node.content}</p>
                  </div>
                </div>
              )
            })}
          </div>
        ) : null}
      </div>
    </section>
  )
}

export default OurFeatures
